import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Blog');
  }

}
